import { OperatorFunction } from 'rxjs';
import { map } from 'rxjs/operators';
import { MapHlp } from 'src/lib/fliko/helpers/map.helper';
import { KeyOf } from 'src/lib/fliko/types/nestedKey.type';

export function fieldsMap<T>(mapKey: KeyOf<T>): OperatorFunction<T[] | null | undefined, Map<string, T>>;

export function fieldsMap<T, U extends T[KeyOf<T>]>(
  mapKey: KeyOf<T>,
  fieldKey: KeyOf<T>
): OperatorFunction<T[] | null | undefined, Map<string, U>>;

export function fieldsMap<T, U>(
  mapKey: KeyOf<T>,
  fieldParser: (obj: T) => U
): OperatorFunction<T[] | null | undefined, Map<string, U>>;

export function fieldsMap<T, U>(
  mapKey: KeyOf<T>,
  fieldGetter?: ((obj: T) => U) | KeyOf<T>
): OperatorFunction<T[] | null | undefined, Map<string, U>> {
  // HACK: Andrzej kazał xD
  // @ts-expect-error arguments match MapHlp.fieldsMap implementation, but not current overloads
  return map((x) => MapHlp.fieldsMap(x ?? [], mapKey, fieldGetter));
}
